import { defineComponent as _defineComponent } from 'vue'
import { queries, mutations } from "@/apollo";
import { User, Payment } from "@/CodegenTypes";

import { formatDollar } from "@/helpers/formatDollar";
import { errorMutationNotification } from "@/utils";
import { customMoment } from "@/main";
import { PAYMENT_TYPE_DISPLAY } from "@/constants";
import { fixRounding } from "@/helpers/fixRounding";
import { computed, ref } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute } from "vue-router/composables";
import { apolloClient } from "@/apollo";
import { addSuccessToast, primeVueConfirm } from "@/vue-service";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentHistory',
  setup(__props) {

const route = useRoute()
const { result, refetch, loading } = useQuery<{ user: User }>(queries.userWithPaymentHistory, {
  userId: route.query.userId,
})


const { $t } = useTranslation();


const startIndex = ref(0);
const PER_PAGE = 100;

const totalEntriesCount = computed(() => {

  return result.value?.user.paymentHistory.length;
})


const paginatedPaymentHistory = computed(() => {

  const endIndex = startIndex.value + PER_PAGE;
  return result.value?.user.paymentHistory.slice(startIndex.value, endIndex) || [];
})


const submitting = ref(false);

function formatPaymentType(paymentType: Payment["paymentType"]) {
  if (!paymentType) {
    return "";
  }
  return PAYMENT_TYPE_DISPLAY[paymentType].display;
}

function formatDrawDate(dateStr?: string) {
  if (!dateStr) {
    return null;
  }
  return customMoment(dateStr).format("ddd, DD/MM/YYYY");
}
function formatDate(dateStr: string) {
  return customMoment(dateStr).format("ddd, DD/MM/YYYY hh:mm:ss A");
}

async function deletePayment(id: Payment["id"]) {
  const { isOk } = await primeVueConfirm({
    title: "Delete payment?",
    text: "This action cannot be undone.",
    icon: "question",
  });

  if (!isOk) {
    return;
  }
  try {
    submitting.value = true;
    await apolloClient.mutate({
      mutation: mutations.deletePayment,
      variables: {
        id,
      },
    });
    addSuccessToast("Payment deleted.");
    reloadAll();
  } catch (err) {
    errorMutationNotification(err);
  }
  submitting.value = false;
}

function reloadAll() {
  refetch()
}

return { __sfc: true,route, result, refetch, loading, $t, startIndex, PER_PAGE, totalEntriesCount, paginatedPaymentHistory, submitting, formatPaymentType, formatDrawDate, formatDate, deletePayment, reloadAll, formatDollar, fixRounding }
}

})